// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// Styles
import * as css from '../../admin/MantenedorPersonal/tablaPersonal.css'
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'

export class TablaAPI extends React.Component {

  render(){
        return (
            <div style={{height: '50%'}} className="row">
                <AutoSizer>
                    {({height, width}) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.detalle.length}
                            rowGetter={({index})=> this.props.detalle[index]}
                            rowHeight={30}
                            rowClassName={({index})=> index<0? css.headerRowAPI : ((index%2===0)? css.evenRowAPI : css.oddRowAPI)}
                        >
                            <Column
                                dataKey='lider' label='Lider'
                                headerRenderer={()=>
                                    <HeaderConFiltro
                                        nombre='Lider'
                                        filtro={this.props.filtros.filtroLideres || []}
                                        actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroLideres')}
                                    />
                                }
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={170}
                                className={css.celdaAPILider}
                            />
                            <Column
                                dataKey='real' label="real lider"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={130}
                                className={css.celdaAPI}
                            />
                            <Column
                                dataKey='necesarias' label="necesidad max"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={130}
                                className={css.celdaAPI}
                            />
                            <Column
                                dataKey='faltantes' label="suministrar"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={130}
                                className={css.celdaAPI}
                            />
                            <Column
                                dataKey='excedente' label="Excedentes"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={130}
                                className={css.celdaAPI}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/TablaAPI.jsx